<p-dialog
    [(visible)]="show"
    [header]="'Update Load ' + ((_load | async)?.propakBOLNumber ?? '')"
    showEffect="fade"
    [modal]="true"
    appendTo="body">

  <form [formGroup]="form" (ngSubmit)="SaveLoad()">

    <div class="p-grid">
      <div class="form-group p-col-6">
        <label for="sealnum" [ngClass]="{'required':shipLoad}">Seal Number</label>
        <input id="sealnum" type="text" pInputText formControlName="sealNumber" />
        <error-block
                [field]="form.controls.sealNumber"
                [messages]="{ required: 'Seal Number is required.' }">
        </error-block>
      </div>
      <div class="form-group p-col-6">
        <label for="customerReferenceNumber" [ngClass]="{'required':customerReferenceRequired && shipLoad}">Customer Reference Number</label>
        <input id="customerReferenceNumber" type="text" pInputText formControlName="customerReferenceNumber" />
        <error-block
          [field]="form.controls.customerReferenceNumber"
          [messages]="{
          required: 'Customer Reference is required.',
          pattern: 'Customer Reference # must be alpha numeric',
          numberInUse: 'Reference # is already in use.'}">
        </error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-6">
        <label>Customer</label>
        <div class="staticfield">{{ selectedCustomer?.accountName }}</div>
      </div>
      <div class="p-col-6">
        <label>Pooler</label>
        <div class="staticfield">{{ selectedPooler?.accountName }}</div>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-12">
        <label [ngClass]="{'required':shipLoad}" for="shipToLocation">Ship To Location</label>
        <div class="p-inputgroup">
          <p-dropdown
            [options]="poolerSiteSelects"
            [filter]="true"
            [editable]="false"
            [resetFilterOnHide]="true"
            inputId="shipToLocation"
            placeholder="-- Select Ship To Location --"
            appendTo="body"
            formControlName="customerSiteId">
            <ng-template pTemplate="item" let-item>
              <span [ngClass]="item.styleClass">{{item.label}}</span>
            </ng-template>
          </p-dropdown>
          <button pButton type="button"
              icon="pi pi-plus"
              [label]="form.controls.customerSiteId.value ? 'Update Address' : 'Add Ship To'"
              (click)="showDialogToAddShipTo()"
              [disabled]="form.disabled || load?.shippedWorkedShiftId">
          </button>
        </div>
        <error-block [field]="form.controls.customerSiteId" [messages]="{
          required: 'Ship To Location is required.',
          noAddress: 'Ship To Location has no address'
        }"></error-block>
        <app-add-shipped-to-form
          [(showDialog)]="displayAddShipToDialog"
          [makeGlidRequired]="cfGlidRequired"
          [customer]="selectedPooler"
          [poolerName]="selectedPooler?.accountName"
          [updateOf]="getPoolerSite()"
          [siteId]="(_load | async)?.site?.id"
          (update)="customerSiteAdded($event)">
        </app-add-shipped-to-form>
      </div>
    </div>

    <p-accordion *ngIf="show" [activeIndex]="activeIndex" #shipShiftAccordion (onOpen)="SetShipLoad(true)" (onClose)="SetShipLoad(false)">
      <p-accordionTab header="Ship Load">
        <div class="p-grid">
          <div class="form-group p-col-12 p-md-6">
            <label class="required" for="shipshift">Ship Date/Shift</label>
            <app-worked-shift-selector
              formControlName="shippedShiftId"
              (workedShiftSelected)="WorkedShiftSelected($event)"
              (dateSelected)="onShippedShiftDateChanged($event)"
            >
            </app-worked-shift-selector>
            <error-block
              [field]="form.controls.shippedShiftId"
              [messages]="{ required: 'Shipped Shift is required.' }">
            </error-block>
          </div>
          <div class="form-group p-col-12 p-md-6">
            <label for="shippedTime" class="required">Ship Time</label>
            <div class="p-inputgroup">
              <p-calendar inputId="dateShipped" formControlName="dateShipped" [showIcon]="true" appendTo="body"></p-calendar>
              <time-entry [displaySeconds]="false" formControlName="shippedTime" [timezone]="siteTimezone"></time-entry>
            </div>
            <error-block
              [field]="form.controls.dateShipped"
              [messages]="{ required: 'Shipped Date is required.' }">
            </error-block>
            <error-block
              [field]="form.controls.shippedTime"
              [messages]="{ required: 'Shipped Time is required.' }">
            </error-block>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
    <div class="form-buttons">
      <button
        pButton
        [label]="shipLoad ? 'Save And Ship Load' : 'Save And Close'"
        icon="pi pi-check"
        type="submit"
        [ngClass]="{'p-state-disabled': !form.valid, 'p-button-success': true }">
      </button>
    </div>
  </form>
</p-dialog>
